import { FIGHT_PROTOCOL_LOADED } from 'actions';

const initialState = { byId: {} };

/**
 * Protocol sheets by id.
 *
 * Only the sheet that changed becomes a new object; its siblings keep their
 * identity so React skips them. The panel for a fight being scored re-renders;
 * nothing else on the workspace does.
 */
const listReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case FIGHT_PROTOCOL_LOADED: {
            if (!action.protocol || !action.protocol.id) {
                return state;
            }

            return {
                ...state,
                byId: { ...state.byId, [action.protocol.id]: action.protocol },
            };
        }

        default:
            return state;
    }
};

export default listReducer;
